import api from './api'

export const registroPesoService = {
  // Listar registros de peso de una mascota
  async getByMascota(idMascota, params = {}) {
    const response = await api.get(`/mascotas/${idMascota}/registros-peso`, { params })
    return response.data
  },

  // Obtener registro específico
  async getById(id) {
    const response = await api.get(`/registros-peso/${id}`)
    return response.data
  },

  // Crear registro de peso
  async create(data) {
    const response = await api.post('/registros-peso', data)
    return response.data
  },

  // Actualizar registro de peso
  async update(id, data) {
    const response = await api.put(`/registros-peso/${id}`, data)
    return response.data
  },

  // Eliminar registro de peso
  async delete(id) {
    const response = await api.delete(`/registros-peso/${id}`)
    return response.data
  },
}

